import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_PLAN_DE_EMBARQUE_ACTIVO } from '../../../../config/tables'

function TablaPlanDeEmbarqueActivo () {
  return (
    <MuiTable id={TABLA_PLAN_DE_EMBARQUE_ACTIVO} />
  )
}

export default TablaPlanDeEmbarqueActivo
